<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.searchKey"
              :placeholder="
                $l('form_label_chaxunch') ||
                  '接收人/抄送人/消息标题/消息内容/扩展参数/消息可变参数......'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="openEditPage({ pageType: 'add' })"
              v-if="allow('A')"
            >
              <!-- <b-icon-plus></b-icon-plus> -->
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_taskStatus') || '发送状态'"
            >
              <el-checkbox-group v-model="form.taskStatusList">
                <el-checkbox label="Y" name="type">{{
                  this.$l('form_label_taskStatus_Y') || '待推送'
                }}</el-checkbox>
                <el-checkbox label="N" name="type">{{
                  this.$l('form_label_taskStatus_N') || '已发送'
                }}</el-checkbox>
                <el-checkbox label="E" name="type">{{
                  this.$l('form_label_taskStatus_E') || '推送失败'
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
           <el-col :span="12">
            <el-form-item
              :label="$l('form_label_timeliness') || '时效类型'"
            >
             <dict-select
                clearable
                v-model="form.timeliness"
                 :body="{ dictType: 'timeliness' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                size="small"
                url="/sys/common/dict/system"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_receiver') || '接收人'"
            >
              <el-input
                v-model.trim="form.receiver"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_copyTo') || '抄送人'">
              <el-input
                v-model.trim="form.copyTo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
           <el-col :span="12">
            <el-form-item :label="$l('table_label_templateId') || '消息模版id'">
              <el-input
                v-model.trim="form.templateId"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_title') || '消息标题'">
              <el-input
                v-model.trim="form.title"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_content') || '消息内容'">
              <el-input
                v-model.trim="form.content"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('table_label_variables') || '消息可变参数'">
              <el-input
                v-model.trim="form.variables"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_extraParams') || '扩展参数'">
              <el-input
                v-model.trim="form.extraParams"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
         </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  searchKey: '',
  taskStatusList: ['Y', 'N', 'E'],
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      orgParams: {}
    }
  },
  created() {
    this.query()
    this.$eventBus.$on('userSaveSuccess', () => {
      this.query()
    })
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.searchKey = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
